import React, { useMemo } from "react";
import AnswerScale from "../AnswerScale";
import PropTypes from "prop-types";
import noop from "../../../services/noop";

export const choicesRange = (scale, low, high) => {
  let choices = [];
  for (let i = 1; i <= scale; i++) {
    i === 1
      ? choices.push({ value: "1", label: low })
      : i === scale
      ? choices.push({ value: String(scale), label: high })
      : choices.push({ value: String(i) });
  }
  return choices;
};

const AnswerRangeNumeric = (props) => {
  const choicesRangeVal = useMemo(
    () => choicesRange(props.scale, props.low, props.high),
    [props.scale, props.low, props.high]
  );
  return (
    <AnswerScale
      data-testid="answer-test"
      handleChange={props.handleChange}
      question={props.question}
      required={props.required}
      choices={choicesRangeVal}
      value={props.value}
      endpointLow={props.low}
      endpointHigh={props.high}
      helperText={props.helperText}
      currentTheme={props.currentTheme}
      ascending={true}
      smScaleBreakPoint={7}
    />
  );
};

AnswerRangeNumeric.propTypes = {
  low: PropTypes.string,
  middle: PropTypes.string,
  high: PropTypes.string,
  question: PropTypes.string.isRequired,
  handleChange: PropTypes.func,
  scale: PropTypes.number,
};

AnswerRangeNumeric.defaultProps = {
  low: "",
  middle: "",
  high: "",
  handleChange: noop,
  scale: 10,
};

export default AnswerRangeNumeric;
